import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={41.273}
      viewBox="0 0 40 41.273"
      {...props}
    >
      <g data-name="Component 40 \u2013 1">
        <g data-name="Group 317" fill="#fff">
          <path
            data-name="Path 7361"
            d="M16.481 24.261h-.161V21.85a.483.483 0 00-.823-.341l-.643.643a.482.482 0 00.5.8v1.309h-.161a.482.482 0 100 .964h1.286a.482.482 0 100-.964z"
          />
          <path
            data-name="Path 7362"
            d="M18.96 21.365a1.448 1.448 0 00-1.446 1.447v.964a1.447 1.447 0 102.893 0v-.964a1.448 1.448 0 00-1.447-1.447zm.482 2.411a.482.482 0 11-.964 0v-.964a.482.482 0 11.964 0z"
          />
          <path
            data-name="Path 7363"
            d="M22.405 21.365a1.448 1.448 0 00-1.446 1.447v.964a1.447 1.447 0 102.893 0v-.964a1.448 1.448 0 00-1.447-1.447zm.482 2.411a.482.482 0 01-.964 0v-.964a.482.482 0 01.964 0z"
          />
          <path
            data-name="Path 7364"
            d="M24.886 22.328a.482.482 0 10-.482-.482.482.482 0 00.482.482z"
          />
          <path
            data-name="Path 7365"
            d="M26.727 21.425a.482.482 0 00-.656.187l-1.607 2.893a.482.482 0 10.843.468l1.607-2.893a.482.482 0 00-.187-.655z"
          />
          <path
            data-name="Path 7366"
            d="M26.493 24.257a.482.482 0 10.482.482.482.482 0 00-.482-.482z"
          />
          <path
            data-name="Path 7367"
            d="M4.866 28.084a.482.482 0 00.482-.482.483.483 0 01.482-.482h30.028a.483.483 0 01.482.482.482.482 0 00.964 0 1.448 1.448 0 00-1.447-1.447h-.463a1.4 1.4 0 00-.381-.56l-1.629-1.455.951-1.965a1.4 1.4 0 00-.8-1.926l-2.062-.717.127-2.18a1.4 1.4 0 00-1.474-1.474l-2.18.127-.717-2.062a1.4 1.4 0 00-1.927-.8l-1.965.951-1.453-1.626a1.4 1.4 0 00-2.085 0l-1.451 1.631-1.964-.951a1.4 1.4 0 00-1.927.8l-.717 2.062-2.18-.127a1.4 1.4 0 00-1.476 1.472l.127 2.18-2.062.717a1.4 1.4 0 00-.8 1.926l.957 1.962-1.631 1.455a1.4 1.4 0 00-.381.56h-.463a1.448 1.448 0 00-1.447 1.447.482.482 0 00.482.482zm4.353-3.463a.482.482 0 00.113-.57l-1.11-2.293a.431.431 0 01.247-.6l2.406-.837a.482.482 0 00.323-.484l-.148-2.543a.431.431 0 01.456-.456l2.543.148a.482.482 0 00.484-.323l.837-2.406a.431.431 0 01.6-.247l2.293 1.11a.483.483 0 00.57-.113l1.694-1.9a.431.431 0 01.644 0l1.694 1.9a.482.482 0 00.57.113l2.293-1.11a.431.431 0 01.6.247l.837 2.406a.482.482 0 00.484.323l2.535-.146a.431.431 0 01.455.456l-.149 2.544a.482.482 0 00.323.484l2.407.837a.431.431 0 01.246.6l-1.11 2.293a.482.482 0 00.113.57l1.723 1.534H12.163a8.7 8.7 0 018.681-8.218 8.735 8.735 0 018.5 6.881.485.485 0 00.471.382.446.446 0 00.1-.011.483.483 0 00.371-.572 9.66 9.66 0 00-19.1 1.534h-3.7z"
          />
          <path
            data-name="Path 7368"
            d="M36.822 30.975a.482.482 0 00-.482.482.483.483 0 01-.482.482H5.831a.483.483 0 01-.482-.482.482.482 0 10-.964 0 1.448 1.448 0 001.447 1.447h3.706l.685.686-.139 2.329a1.4 1.4 0 001.474 1.474l2.18-.127.717 2.062a1.4 1.4 0 001.927.8l1.965-.951 1.451 1.631a1.4 1.4 0 002.085 0l1.451-1.631 1.965.951a1.4 1.4 0 001.926-.8l.717-2.062 2.18.127a1.4 1.4 0 001.474-1.474l-.135-2.327.686-.686h3.707a1.448 1.448 0 001.447-1.447.482.482 0 00-.479-.484zm-6.333 2.454l.148 2.543a.431.431 0 01-.456.456l-2.543-.148a.482.482 0 00-.484.323l-.837 2.407a.431.431 0 01-.6.246l-2.293-1.11a.482.482 0 00-.57.114l-1.694 1.9a.431.431 0 01-.644 0l-1.694-1.9a.483.483 0 00-.57-.114l-2.293 1.11a.431.431 0 01-.6-.247l-.837-2.406a.481.481 0 00-.484-.323l-2.543.148a.431.431 0 01-.456-.456l.148-2.543a.482.482 0 00-.14-.369l-.157-.156h15.96a8.677 8.677 0 01-11.468.5.482.482 0 10-.606.75 9.614 9.614 0 006.054 2.139 9.639 9.639 0 007.341-3.39h2.6l-.156.157a.482.482 0 00-.125.371z"
          />
          <path
            data-name="Path 7369"
            d="M7.204 28.566h.354a.482.482 0 100-.964h-.354a1.929 1.929 0 101.929 1.929.482.482 0 00-.482-.482h-.835a.482.482 0 100 .964h.224a.965.965 0 11-.836-1.447z"
          />
          <path
            data-name="Path 7370"
            d="M9.999 27.602a.482.482 0 00-.482.482v1.746a1.64 1.64 0 003.279 0v-1.746a.482.482 0 00-.964 0v1.746a.675.675 0 01-1.35 0v-1.746a.482.482 0 00-.483-.482z"
          />
          <path
            data-name="Path 7371"
            d="M14.597 27.602a.482.482 0 00-.451.313l-1.085 2.893a.482.482 0 00.9.339l.063-.169h1.14l.064.169a.482.482 0 10.9-.339l-1.085-2.893a.482.482 0 00-.446-.313zm-.208 2.411l.208-.556.208.556z"
          />
          <path
            data-name="Path 7372"
            d="M19.572 29.049a1.444 1.444 0 00-1.438-1.447h-.94a.482.482 0 00-.482.482v2.893a.482.482 0 00.964 0v-.482h.257l.815.822a.482.482 0 10.685-.679l-.432-.436a1.448 1.448 0 00.571-1.153zm-1.438.482h-.458v-.964h.458a.482.482 0 010 .964z"
          />
          <path
            data-name="Path 7373"
            d="M21.62 27.602a.482.482 0 00-.451.313l-1.085 2.893a.482.482 0 10.9.339l.063-.169h1.14l.064.169a.482.482 0 10.9-.339l-1.085-2.893a.482.482 0 00-.446-.313zm-.208 2.411l.208-.556.208.556z"
          />
          <path
            data-name="Path 7374"
            d="M25.792 28.084v1.42l-1.251-1.705a.482.482 0 00-.871.285v2.893a.482.482 0 00.964 0v-1.42l1.251 1.705a.482.482 0 00.871-.285v-2.893a.482.482 0 00-.964 0z"
          />
          <path
            data-name="Path 7375"
            d="M28.606 31.459a.482.482 0 00.482-.482v-2.411h.611a.482.482 0 000-.964h-2.181a.482.482 0 100 .964h.611v2.411a.482.482 0 00.477.482z"
          />
          <path
            data-name="Path 7376"
            d="M32.425 28.566a.482.482 0 000-.964h-1.479a.482.482 0 00-.482.482v2.893a.482.482 0 00.482.482h1.479a.482.482 0 000-.964h-1v-.482h.611a.482.482 0 000-.964h-.611v-.482z"
          />
          <path
            data-name="Path 7377"
            d="M35.417 28.566a.482.482 0 100-.964h-1.479a.482.482 0 00-.482.482v2.893a.482.482 0 00.482.482h1.479a.482.482 0 100-.964h-1v-.482h.611a.482.482 0 000-.964h-.611v-.482z"
          />
        </g>
        <text
          data-name="\u0636\u0645\u0627\u0646\u062A \u062A\u0639\u0648\u06CC\u0636"
          transform="translate(20 7)"
          fill="#fff"
          fontSize={6}
          fontFamily="IRANYekanFN-Medium, IRANYekanFN"
          fontWeight={500}
        >
          <tspan x={19.226} y={0}>
            {"\u0636\u0645\u0627\u0646\u062A \u062A\u0639\u0648\u06CC\u0636"}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
